import { jsx, Fragment } from "react/jsx-runtime";
import { f as FlashErrorMessage } from "./index-BEglnXN9.js";
const FormikErrorFlashList = ({ errors }) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Object.keys(errors).map((key) => /* @__PURE__ */ jsx(FlashErrorMessage, { name: key }, key)) });
};
export {
  FormikErrorFlashList as F
};
//# sourceMappingURL=FormikErrorFlashList-CICftIxB.js.map
